module.exports = __webpack_public_path__ + "static/media/ellipse-vert.44ad6a28.svg";